import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChoiceGroup, IChoiceGroupOption } from "@fluentui/react/lib/ChoiceGroup";
import { Stack } from "@fluentui/react/lib/Stack";

import { save, STORAGE_KEYS } from "API/LocalStorage";
import { IWithTranslatorProps, WithTranslator } from "Components/Generic/Translator";
import { ThemeType } from "Model/Configuration/ITheme";
import { uiSetTheme } from "Store/Actions";
import { selectTheme } from "Store/Selectors/UI";

const iconMap = {
  [ThemeType.Light]: `Sunny`,
  [ThemeType.Dark]: `ClearNight`,
  [ThemeType.Auto]: `Light`
};

export const Theme = WithTranslator(({ translator }: IWithTranslatorProps): JSX.Element => {
  const dispatch = useDispatch();
  const currentTheme = useSelector(selectTheme);

  const onChange = useCallback(
    (_, option: IChoiceGroupOption) => {
      save(STORAGE_KEYS.THEME_CONFIG, option.key as ThemeType);
      dispatch(uiSetTheme(option.key));
    },
    [dispatch]
  );

  const options: IChoiceGroupOption[] = useMemo(
    () => Object.entries(ThemeType).map(([, value]) => ({
      key: value as string,
      text: translator.get(`settings.theme.${value}`, `~${value}~`),
      iconProps: { iconName: iconMap[value] }
    })),
    [translator]
  );

  return (
    <Stack horizontal>
      <ChoiceGroup
        defaultSelectedKey={currentTheme}
        label={`${translator.get(`settings.theme.label`, `Select Language`)}...`}
        onChange={onChange}
        options={options}
      />
    </Stack>
  );
});
